<script>
    export let bytes

    const get_human_size = size => {
        const approx = Math.log2(size)

        if (approx > 30) {
            return `${Math.ceil(size/(1024*1024*1024))}GB`
        } else if (approx > 20) {
            return `${Math.ceil(size/(1024*1024))}MB`
        } else if (approx > 10) {
            return `${Math.ceil(size/(1024))}KB`
        } else {
            return `${size}B`
        }
    }
</script>

<span>{get_human_size(bytes)}</span>


